const projects = [
  {
    title: "Silomba",
    slug: "silomba-production",
    category: "Web & Mobile Development",
    year: "2025",
    stack: [
      "Next.js",
      "React",
      "Flutter",
      "Node.js",
      "PostgreSQL",
      "Docker",
      "Jenkins",
    ],
    featured: true,
    image: require("../assets/project-thumbnails/Silomba.png"),
    link: "https://silomba.id/",
    background:
      "Silomba is a competition finder platform that helps students discover, apply for, and manage competitions with a scalable fullstack architecture supporting both web and mobile applications.",
    problem:
      "Students struggle to find and track relevant competitions from scattered sources, missing deadlines and opportunities for academic and professional growth.",
    solution:
      "A comprehensive fullstack competition platform with REST API, JWT authentication, containerization, and multi-platform support including mobile (Flutter) and web (Next.js) with Instagram Graph API integration.",
    outcome:
      "Production-ready competition platform with scalable architecture, Docker containerization, Jenkins CI/CD pipelines, and VPS deployment with Nginx reverse proxy.",
  },
  {
    title: "Deerank",
    slug: "deerank",
    category: "Web & Mobile Development",
    year: "2026",
    stack: [
      "Next.js",
      "React",
      "Flutter",
      "Node.js",
      "PostgreSQL",
      "Docker",
      "Jenkins",
    ],
    featured: true,
    image: require("../assets/project-thumbnails/Deerank.png"),
    link: "https://deerank.com/",
    background:
      "Deerank is an e-learning application that transforms lengthy and tedious PDF documents into interactive and engaging learning experiences.",
    problem:
      "Students and professionals often find reading long PDF documents or e-books overwhelming and boring, making it difficult to retain information effectively.",
    solution:
      "An intelligent e-learning app that automatically converts uploaded PDFs into structured courses, generates interactive quizzes, and incorporates gamification elements like leaderboards and points.",
    outcome:
      "An engaging, gamified learning platform design that enhances comprehension and retention by turning static documents into interactive study modules.",
  },
  {
    title: "Educa",
    slug: "educa",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: true,
    image: require("../assets/project-thumbnails/Educa.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa-s-Portfolio?page-id=2316%3A165&node-id=2316-630&viewport=404%2C1877%2C0.38&t=zLFcVI6KLyGel2HG-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "Educa is an education mobile app that provides accessibility features (contrast, dyslexic mode, large text size and dark mode) and video-based learning that includes 3 options for student learning styles: visual, auditory, and kinesthetic.",
    problem:
      "Many education apps lack proper accessibility support, making it difficult for students with different needs and learning styles to engage effectively with course content.",
    solution:
      "An education app with built-in accessibility features including contrast adjustment, dyslexic mode, large text size, and dark mode, combined with video-based content tailored to visual, auditory, and kinesthetic learning styles.",
    outcome:
      "A fully accessible education app design that accommodates diverse learning needs and preferences.",
  },
  {
    title: "LokaLearn",
    slug: "lokalearn",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: false,
    image: require("../assets/project-thumbnails/LokaLearn.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=0%3A1&node-id=2-2&p=f&viewport=450%2C75%2C0.04&t=rBSrJESDlS0q6oJK-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "LokaLearn is a mobile-based online programming learning application that applies gamification methods.",
    problem:
      "Learning programming can feel tedious and uninspiring when traditional teaching methods are applied in a mobile app format.",
    solution:
      "A mobile-based programming learning app that integrates gamification methods to make the learning experience more engaging and motivating.",
    outcome:
      "A gamified mobile app design that makes programming education more interactive and enjoyable.",
  },
  {
    title: "LifeSync",
    slug: "lifesync",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: true,
    image: require("../assets/project-thumbnails/LifeSync.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=2040%3A43&node-id=2082-103&p=f&viewport=450%2C50%2C0.05&t=ZSamDFTD7DRnwZYm-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "LifeSync is a health tracking app designed to help users monitor their sleep, calories, nutrition, and steps to achieve their desired BMI.",
    problem:
      "People find it difficult to track multiple health metrics across different apps, making it hard to get a unified view of their progress toward health goals.",
    solution:
      "A unified health tracking app that monitors sleep, calories, nutrition, and steps in one place, helping users work toward their desired BMI with consolidated data.",
    outcome:
      "A comprehensive health tracking app design that unifies key wellness metrics into a single, easy-to-use interface.",
  },
  {
    title: "TinyBloom",
    slug: "tinybloom",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: false,
    image: require("../assets/project-thumbnails/TinyBloom.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=2129%3A43&node-id=2133-133&p=f&viewport=380%2C135%2C0.03&t=7XhSsnr2YvL2uG8M-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "TinyBloom is designed to help parents track and support their child's growth and development through personalized insights and daily activity monitoring.",
    problem:
      "Parents often lack a centralized tool to track their child's developmental milestones and daily activities, making it harder to identify growth patterns.",
    solution:
      "A childcare tracking app that provides personalized insights and daily activity monitoring to help parents stay informed about their child's growth and development.",
    outcome:
      "A thoughtful mobile app design that empowers parents with meaningful insights into their child's development journey.",
  },
  {
    title: "Fundplus",
    slug: "fundplus",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: false,
    image: require("../assets/project-thumbnails/FundPlus.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=16%3A4708&node-id=18-4709&p=f&viewport=450%2C61%2C0.07&t=x11DdQYEJI4ljZzH-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "Fundplus is a financial management application designed to efficiently track and manage personal finances.",
    problem:
      "Managing personal finances can be overwhelming without a clear and efficient tool to track spending, savings, and overall financial health.",
    solution:
      "A financial management app that provides efficient tracking and management tools for personal finances, offering clarity and control over spending habits.",
    outcome:
      "A clean and intuitive financial management app design focused on efficient personal finance tracking.",
  },
  {
    title: "VODFlix",
    slug: "vodflix",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: true,
    image: require("../assets/project-thumbnails/VODFlix.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=29%3A12442&node-id=29-13394&p=f&viewport=560%2C16%2C0.11&t=kLd2tTaSA3QXGiKM-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "VODFlix is a cutting-edge streaming platform offering a vast library of movies.",
    problem:
      "Users need an intuitive and visually appealing streaming platform that makes discovering and watching movies a seamless experience.",
    solution:
      "A modern streaming app design that offers a vast movie library with a user-friendly interface optimized for content discovery and playback.",
    outcome:
      "A polished streaming platform design that delivers a premium movie browsing and viewing experience.",
  },
  {
    title: "Rruby & Co",
    slug: "rruby-and-co",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: false,
    image: require("../assets/project-thumbnails/Rruby & Co.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=2143%3A43&node-id=2158-98&p=f&viewport=450%2C95%2C0.15&t=9RA7v0RUSqLlyPJx-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "Rruby & Co is a platform dedicated to facilitating the buying and selling of exquisite jewelry pieces.",
    problem:
      "The jewelry marketplace lacks a dedicated, elegant digital platform that matches the premium nature of the products being bought and sold.",
    solution:
      "A dedicated jewelry marketplace app designed with a premium aesthetic that facilitates seamless buying and selling of exquisite jewelry pieces.",
    outcome:
      "An elegant marketplace app design that reflects the premium quality of the jewelry products it showcases.",
  },
  {
    title: "Blico",
    slug: "blico",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: false,
    image: require("../assets/project-thumbnails/Blico.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=2421%3A165&node-id=2421-270&viewport=144%2C135%2C0.21&t=XUwEwAdRBmpCgtbY-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "Blico is an innovative electric bike rental app designed to promote sustainable urban mobility, reduce traffic congestion, and support a healthier lifestyle.",
    problem:
      "Urban commuters need accessible and sustainable transportation alternatives that help reduce traffic congestion while promoting healthier travel habits.",
    solution:
      "An electric bike rental app that provides easy access to sustainable urban mobility, helping reduce congestion and encouraging a healthier, more eco-friendly lifestyle.",
    outcome:
      "A forward-thinking mobility app design that promotes sustainable urban transportation through electric bike rentals.",
  },
  {
    title: "Gluvate",
    slug: "gluvate",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: false,
    image: require("../assets/project-thumbnails/Gluvate.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa-s-Portfolio?page-id=2421%3A166&node-id=2421-387&viewport=218%2C40%2C0.27&t=ODHxSejrIqHuwo02-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "Gluvate is an app that helps monitor daily sugar intake, providing alerts and insights to maintain a healthier lifestyle.",
    problem:
      "Many people are unaware of their daily sugar consumption levels, which can lead to health issues over time without proper monitoring and awareness.",
    solution:
      "A sugar intake tracking app that monitors daily consumption and provides timely alerts and actionable insights to help users maintain healthier eating habits.",
    outcome:
      "A health-focused app design that raises awareness of sugar consumption through intuitive tracking and timely alerts.",
  },
  {
    title: "Tanjak",
    slug: "tanjak",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: false,
    image: require("../assets/project-thumbnails/Tanjak.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa's-Portfolio?page-id=2421%3A167&node-id=2421-478&viewport=218%2C40%2C0.27&t=RXlRKWTIelyeJVr3-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "Tanjak is designed to enhance the hiking experience by providing essential tools and information to ensure safety, convenience, and enjoyment for climbers.",
    problem:
      "Hikers often lack a single reliable source for essential preparation tools, safety information, and trail details needed for a safe and enjoyable climbing experience.",
    solution:
      "A hiking preparation app that consolidates essential tools, safety information, and trail details into one platform to ensure convenience and safety for climbers.",
    outcome:
      "A practical hiking companion app design that equips climbers with everything they need for a safe and enjoyable experience.",
  },
  {
    title: "Baystrix",
    slug: "baystrix-landing-page",
    category: "Web Development",
    year: "2026",
    stack: ["Next.js", "React", "Tailwind CSS"], // Sesuaikan dengan tech stack aslimu
    featured: true,
    image: require("../assets/project-thumbnails/Baystrix.png"), // Pastikan nama file gambar sesuai
    link: "https://baystrix.com/",
    background:
      "Baystrix needed a modern and professional landing page to establish their online presence and elegantly showcase their digital products and services.",
    problem:
      "They required a fast, responsive, and visually appealing website that could effectively communicate their value proposition and engage visitors without feeling cluttered or complex.",
    solution:
      "Designed and developed a sleek, high-performance landing page with intuitive navigation, smooth interactions, and an optimized user experience tailored to their brand identity.",
    outcome:
      "A highly responsive and polished website that successfully highlights their offerings and provides a seamless browsing experience across all devices.",
  },
  {
    title: "Silomba",
    slug: "silomba-design",
    category: "Mobile App Design",
    year: "",
    stack: ["Figma", "UI/UX Design", "Prototyping"],
    featured: true,
    image: require("../assets/project-thumbnails/Silomba.png"),
    link: "https://www.figma.com/proto/uv6KTvs1UjaEYdQRIED0la/Nazwa-s-Portfolio?page-id=2618%3A25&node-id=2618-282&viewport=-208%2C419%2C0.23&t=BXkmM0XzJH7ZzGtP-1&scaling=min-zoom&content-scaling=fixed",
    background:
      "Silomba is a competition finder app that helps students discover, track, and manage competitions easily with trusted information, reminders, bookmarks, and a personalized calendar.",
    problem:
      "Students often struggle to find relevant competitions from scattered sources, leading to missed deadlines and lost opportunities for academic and professional growth.",
    solution:
      "A dedicated competition finder app providing trusted competition information, automated reminders, a bookmark system, and a personalized calendar for managing competition timelines.",
    outcome:
      "A complete mobile app design that streamlines competition discovery and management for students.",
  },
];

export default projects;
